/**
 * Copyright (C) 2017 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-desktopnavigation.scss'
import template from 'lui-desktopnavigation.html'

export default class LuiDesktopnavigation extends LuiBase {
  constructor() {
    super()
    console.warn(`[LUI] <lui-desktopnavigation> component is deprecated and will be removed in future versions.
➜ HINT: Replace the component with <lui-navigation>.`)
  }

  static get is() {
    return 'lui-desktopnavigation'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-desktopnavigation/lui-desktopnavigation.js
// module id = 205
// module chunks = 0 1 34